<script>
import VueCharts from 'vue-chartjs'
import { Bar, Line } from 'vue-chartjs'

import api from '@/api'
import { apiV2 } from '@/api/urls'
export default {
  name: 'adx-line-chart',
  extends: Line,
  components: {

  },
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      htmlLegend: null,
      label: [],
      unique: []
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    
  },
  beforeMount() {

  },
  mounted() {
    // this.renderChart({
    //   labels: this.label,
    //   datasets: [
    //     {
    //       label: 'Data One',
    //       backgroundColor: 'transparent',
    //       borderColor: '#FF2D55',
    //       data: this.unique
    //     }
    //   ]
    // }, {responsive: true, maintainAspectRatio: false, legend: false})
    this.renderChart(this.chartdata, this.options)
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>